<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  locales: {
    pt: {
      'My PIX Key': 'Meu PIX',
      'CPF': 'CPF',
      'CNPJ': 'CNPJ',
      'Mobile Phone': 'Celular',
      'E-mail': 'E-mail',
      'Random Key': 'Chave Aleatória',
      'Type': 'Tipo',
      'Key type is required.': 'O tipo de chave é obrigatório.',
      'Key': 'Chave',
      'Key is required.': 'A chave é obrigatória.',
      'Save': 'Salvar',
      'The key has been registered successfully!': 'A chave foi cadastrada com sucesso!',
    },
    es: {
      'My PIX Key': 'Mi Clave PIX',
      'CPF': 'CPF',
      'CNPJ': 'CNPJ',
      'Mobile Phone': 'Celular',
      'E-mail': 'Correo Electrónico',
      'Random Key': 'Clave Aleatoria',
      'Type': 'Tipo',
      'Key type is required.': 'El tipo de clave es obligatorio.',
      'Key': 'Clave',
      'Key is required.': 'La clave es obligatoria.',
      'Save': 'Guardar',
      'The key has been registered successfully!': '¡La clave se registró con éxito!',
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
      loading: false,

      pix: {
        type: null,
        key: null,
        types: {
          cpf: 'CPF',
          cnpj: 'CNPJ',
          cellphone: 'Mobile Phone',
          email: 'E-mail',
          random: 'Random Key'
        },
      }
    };
  },
  validations: {
    pix: {
      type: { required },
      key: { required }
    }
  },
  methods: {
    getPix() {
      api
        .get('user/pix')
        .then((response) => {
          if (response.data.status == 'success') {
            this.pix.type = response.data.type,
              this.pix.key = response.data.key
          }
        })
    },
    pixSubmit() {
      this.loading = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false
        return;
      } else {
        const { type, key } = this.pix;
        if (type && key) {
          api
            .post('user/pix', {
              key: this.pix.key,
              type: this.pix.type
            })
            .then(response => {
              if (response.data.status == 'success') {
                this.$v.$reset()

                this.$toast.success(this.t('The key has been registered successfully!'))
              } else {
                this.$toast.error(this.t(response.data.message))
              }

              this.loading = false
            })
            .catch(error => {
              if (error) {
                this.loading = false
              }
            })
        }
      }
    },
  },
  mounted() {
    this.getPix()
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('My PIX Key') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-body table-responsive">
            <b-form class="p-3" @submit.prevent="pixSubmit">
              <img src="@/assets/images/payments/logo-pix.png" class="mb-4" style="height:50px;">
              <b-form-group id="banco" :label="t('Type')" label-for="banco">
                <select v-model="pix.type" class="custom-select mb-2">
                  <option v-for="(pix, index) in pix.types" :key="index" :value="index">{{ t(pix) }}</option>
                </select>
                <div v-if="$v.pix.type.$error" class="invalid-feedback">
                  <span v-if="!$v.pix.type.required">{{ t('Key type is required.') }}</span>
                </div>
              </b-form-group>
              <b-form-group id="agencia.numero" :label="t('Key')" label-for="agencia.numero">
                <b-form-input id="agencia.numero" v-model="pix.key" type="text" :class="{ 'is-invalid': $v.pix.key.$error }"></b-form-input>
                <div v-if="$v.pix.key.$error" class="invalid-feedback">
                  <span v-if="!$v.pix.key.required">{{ t('Key is required.') }}</span>
                </div>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="this.loading == true" type="submit" variant="default" class="btn-lg btn-block">
                  {{ t('Save') }}
                  <b-spinner v-if="loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>